import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-telecaller',
  templateUrl: './telecaller.component.html',
  styleUrls: ['./telecaller.component.css']
})
export class TelecallerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/prospect/telecaller/telecaller.component.ts